<div class="row">
    <div class="col-md-6 p-0">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            (refreshDataFromServer)="refreshData($event)" (rowSelected)="emitQuestionData($event)"
            [gridName]="'examquestionGrid'" (addClicked)="addQuestion()" (deleteClicked)="deleteQuestion()"
            (exportClicked)="exportQuestionsClicked()"></app-grid>
    </div>
    <div class="col-md-6 p-0">
        <app-update-saq-answers class="question-container" [selectedQuestion]="selectedQuestion"></app-update-saq-answers>
    </div>
</div>